import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "../aseets/css/life-global-manch.css";

import seoExpert from '../aseets/gallery/seo-expert.jpg';
import graphic from '../aseets/gallery/graphic-designer.jpg';
import developer from '../aseets/gallery/web-developer.jpg';
import editor from '../aseets/gallery/video-editor.jpg';

gsap.registerPlugin(ScrollTrigger);

const moments = [
     seoExpert,
     graphic,
     developer,
     editor
];

const mindsets = [
  {
    title: "Ownership",
    belief: "We don’t wait for instructions. We take responsibility."
  },
  {
    title: "Curiosity",
    belief: "Questions matter more than answers."
  },
  {
    title: "Speed",
    belief: "Momentum beats perfection."
  },
  {
    title: "Accountability",
    belief: "Outcomes matter more than effort."
  },
  {
    title: "Learning",
    belief: "Every mistake earns its lesson."
  },
  {
    title: "Experimentation",
    belief: "We test before we assume."
  }
];

const milestones = [
  { label: "Campaigns shipped at 2AM", value: 120 },
  { label: "Ideas tested before coffee", value: 340 },
  { label: "Failures documented", value: 98 },
  { label: "Growth reviews completed", value: 210 }
];

const LifeAtGlobalManch = () => {
  useEffect(() => {
    // MOMENTS AUTO SCROLL
    gsap.to(".gm-life-moments-track", {
      xPercent: -50,
      ease: "none",
      duration: 30,
      repeat: -1
    });

    // MINDSETS FLOAT
    gsap.utils.toArray(".gm-mindset-pill").forEach((pill) => {
      gsap.to(pill, {
        y: gsap.utils.random(-12, 12),
        duration: gsap.utils.random(3, 5),
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut"
      });
    });

    // COUNTERS
    gsap.utils.toArray(".gm-milestone-value").forEach((el) => {
      gsap.fromTo(
        el,
        { innerText: 0 },
        {
          innerText: el.dataset.value,
          duration: 2,
          ease: "power1.out",
          snap: { innerText: 1 },
          scrollTrigger: {
            trigger: el,
            start: "top 80%"
          }
        }
      );
    });
  }, []);

  return (
    <section className="gm-life">

      {/* SECTION HEADER */}
      <header className="gm-life-header">
        <span className="gm-life-eyebrow">LIFE @ GLOBAL MANCH</span>
        <h2 className="gm-life-title">
          Moments build <span>Mindsets</span>.  
          <br />Mindsets create <span>Milestones</span>.
        </h2>
      </header>

      {/* 1️⃣ MOMENTS */}
      <div className="gm-life-moments">
        <div className="gm-life-moments-track">
          {moments.map((img, i) => (
            <div key={i} className="gm-life-moment">
              <img src={img} alt="life moment" />
            </div>
          ))}
        </div>
      </div>

      {/* 2️⃣ MINDSETS */}
      <div className="gm-life-mindsets">
        {mindsets.map((m, i) => (
          <div key={i} className="gm-mindset-pill">
            <span className="gm-mindset-title">{m.title}</span>
            <span className="gm-mindset-belief">{m.belief}</span>
          </div>
        ))}
      </div>

      {/* 3️⃣ MILESTONES */}
      <div className="gm-life-milestones">
        {milestones.map((m, i) => (
          <div key={i} className="gm-milestone">
            <div
              className="gm-milestone-value"
              data-value={m.value}
            >
              0
            </div>
            <p>{m.label}</p>
          </div>
        ))}
      </div>

    </section>
  );
};

export default LifeAtGlobalManch;
